import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Story from "@/components/site/Story";
import MenuBoard from "@/components/site/MenuBoard";
import Events from "@/components/site/Events";
import Gallery from "@/components/site/Gallery";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  const [eventType, setEventType] = useState("vendor");

  const handleBookType = (type) => {
    setEventType(type);
    const el = document.getElementById("book");
    if (!el) return;
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -72 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <MenuBoard />
        <Events onBookType={handleBookType} />
        <Gallery />
        <BookingForm eventType={eventType} onEventTypeChange={setEventType} />
      </main>
      <Footer />
    </div>
  );
}
